var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 560",
    width: 560,
    height: 560,
    role: "img",
    "aria-label": "Pelvic health analytics dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pelvic Health Analytics dashboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hdBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#EAF3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EDF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hdArea",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#257CFF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hdRing",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#011936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#257CFF"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hdShadow",
    x: "-25%",
    y: "-25%",
    width: "150%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 16,
    floodColor: "#011936",
    floodOpacity: 0.14
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hdChip",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 9,
    floodColor: "#011936",
    floodOpacity: 0.13
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hdBlur",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hdClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 280,
    r: 280
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hdClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 560,
    fill: "url(#hdBg)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 110,
    r: 96,
    fill: "#257CFF",
    opacity: 0.34,
    filter: "url(#hdBlur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 470,
    cy: 470,
    r: 104,
    fill: "#59C3FF",
    opacity: 0.38,
    filter: "url(#hdBlur)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 452,
    cy: 120,
    r: 70,
    fill: "#CFE2FF",
    opacity: 0.3,
    filter: "url(#hdBlur)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hdChip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 46,
    width: 260,
    height: 44,
    rx: 22,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 68,
    r: 12,
    fill: "#011936"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 62.2l1.9 4.2 4.4.5-3.3 3 .9 4.3-3.9-2.3-3.9 2.3.9-4.3-3.3-3 4.4-.5z",
    fill: "#59C3FF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 64.5,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#011936"
  }, "AI insight"), /*#__PURE__*/React.createElement("text", {
    x: 196,
    y: 78,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 10.5,
    fill: "#7C8AA5"
  }, "14 patients need follow-up"), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hdShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 112,
    width: 432,
    height: 336,
    rx: 22,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 101,
    cy: 149,
    r: 14,
    fill: "url(#hdRing)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5 149h4l2-4.5 3 9 2.5-4.5h4",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 145,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 14.5,
    fontWeight: 600,
    fill: "#011936"
  }, "Pelvic Health Analytics"), /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 161,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 10.5,
    fill: "#7C8AA5"
  }, "Population overview &#183; Last 30 days"), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 137,
    width: 68,
    height: 25,
    rx: 12.5,
    fill: "#EEF7EE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 149.5,
    r: 4,
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("text", {
    x: 428,
    y: 153.5,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 10.5,
    fontWeight: 600,
    fill: "#2E9E45"
  }, "Live"), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 184,
    x2: 472,
    y2: 184,
    stroke: "#EDF1F7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 198,
    width: 121,
    height: 72,
    rx: 13,
    fill: "#F6F9FE",
    stroke: "#E7EEF9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 219,
    fontSize: 9.5,
    fill: "#7C8AA5",
    letterSpacing: 0.4
  }, "ACTIVE PATIENTS"), /*#__PURE__*/React.createElement("text", {
    x: 102,
    y: 243,
    fontSize: 21,
    fontWeight: 700,
    fill: "#011936"
  }, "12,480"), /*#__PURE__*/React.createElement("path", {
    d: "M103 254.5l4-4.5 4 4.5z",
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 257,
    fontSize: 10,
    fontWeight: 600,
    fill: "#2E9E45"
  }, "8.2%"), /*#__PURE__*/React.createElement("rect", {
    x: 219.5,
    y: 198,
    width: 121,
    height: 72,
    rx: 13,
    fill: "#F6F9FE",
    stroke: "#E7EEF9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 233.5,
    y: 219,
    fontSize: 9.5,
    fill: "#7C8AA5",
    letterSpacing: 0.4
  }, "SYMPTOM SCORE"), /*#__PURE__*/React.createElement("text", {
    x: 233.5,
    y: 243,
    fontSize: 21,
    fontWeight: 700,
    fill: "#011936"
  }, "4.1"), /*#__PURE__*/React.createElement("path", {
    d: "M234.5 250.5l4 4.5 4-4.5z",
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("text", {
    x: 246.5,
    y: 257,
    fontSize: 10,
    fontWeight: 600,
    fill: "#2E9E45"
  }, "12%"), /*#__PURE__*/React.createElement("rect", {
    x: 351,
    y: 198,
    width: 121,
    height: 72,
    rx: 13,
    fill: "#F6F9FE",
    stroke: "#E7EEF9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 219,
    fontSize: 9.5,
    fill: "#7C8AA5",
    letterSpacing: 0.4
  }, "ADHERENCE"), /*#__PURE__*/React.createElement("text", {
    x: 365,
    y: 243,
    fontSize: 21,
    fontWeight: 700,
    fill: "#011936"
  }, "87%"), /*#__PURE__*/React.createElement("path", {
    d: "M366 254.5l4-4.5 4 4.5z",
    fill: "#3CD856"
  }), /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 257,
    fontSize: 10,
    fontWeight: 600,
    fill: "#2E9E45"
  }, "5.4%")), /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 294,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#011936"
  }, "Treatment response trend"), /*#__PURE__*/React.createElement("circle", {
    cx: 366,
    cy: 290,
    r: 4,
    fill: "#011936"
  }), /*#__PURE__*/React.createElement("text", {
    x: 375,
    y: 293.5,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 9.5,
    fill: "#7C8AA5"
  }, "Treated"), /*#__PURE__*/React.createElement("circle", {
    cx: 424,
    cy: 290,
    r: 4,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("text", {
    x: 433,
    y: 293.5,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 9.5,
    fill: "#7C8AA5"
  }, "Baseline"), /*#__PURE__*/React.createElement("g", {
    stroke: "#F0F4FA",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 312,
    x2: 472,
    y2: 312
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 341,
    x2: 472,
    y2: 341
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 370,
    x2: 472,
    y2: 370
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: 399,
    x2: 472,
    y2: 399
  })), /*#__PURE__*/React.createElement("path", {
    d: "M88 376C118 376 122 360 152 360S186 352 216 352S250 334 280 334S314 324 344 324S378 312 408 312S442 302 472 302L472 399L88 399Z",
    fill: "url(#hdArea)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 376C118 376 122 360 152 360S186 352 216 352S250 334 280 334S314 324 344 324S378 312 408 312S442 302 472 302",
    fill: "none",
    stroke: "#011936",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 384C118 384 122 379 152 379S186 377 216 377S250 372 280 372S314 369 344 369S378 365 408 365S442 361 472 361",
    fill: "none",
    stroke: "#CFE2FF",
    strokeWidth: 2,
    strokeDasharray: "5 5",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#011936",
    strokeWidth: 2.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 360,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 334,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 408,
    cy: 312,
    r: 4
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 472,
    cy: 302,
    r: 6.5,
    fill: "#011936"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472,
    cy: 302,
    r: 11,
    fill: "#011936",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 9.5,
    fill: "#9AA7BC",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 88,
    y: 416
  }, "W1"), /*#__PURE__*/React.createElement("text", {
    x: 184,
    y: 416
  }, "W2"), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 416
  }, "W3"), /*#__PURE__*/React.createElement("text", {
    x: 376,
    y: 416
  }, "W4"), /*#__PURE__*/React.createElement("text", {
    x: 468,
    y: 416
  }, "W5")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#hdChip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 466,
    width: 268,
    height: 48,
    rx: 24,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 490,
    r: 13,
    fill: "#CFE2FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 485.5,
    r: 4.4,
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.6 498c1.2-4.2 4.2-6.2 7.4-6.2s6.2 2 7.4 6.2z",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 490,
    r: 13,
    fill: "#CFE2FF",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 485.5,
    r: 4.4,
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.6 498c1.2-4.2 4.2-6.2 7.4-6.2s6.2 2 7.4 6.2z",
    fill: "#257CFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 490,
    r: 13,
    fill: "#DCF2FF",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216,
    cy: 485.5,
    r: 4.4,
    fill: "#59C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.6 498c1.2-4.2 4.2-6.2 7.4-6.2s6.2 2 7.4 6.2z",
    fill: "#59C3FF"
  })), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 486,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 600,
    fill: "#011936"
  }, "3 new case reviews"), /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 500,
    fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif",
    fontSize: 10.5,
    fill: "#7C8AA5"
  }, "Shared by your care team"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroDashboard);
export default __webpack_public_path__ + "static/media/hero-dashboard.e7337ff5130db2ea8bc1e68d0c1b92c6.svg";
export { ForwardRef as ReactComponent };